import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Cammino from "@/pages/Cammino";
import Tappe from "@/pages/Tappe";
import TappaDetail from "@/pages/TappaDetail";
import Territorio from "@/pages/Territorio";
import Prodotti from "@/pages/Prodotti";
import Servizi from "@/pages/Servizi";
import Progetto from "@/pages/Progetto";
import Partner from "@/pages/Partner";
import Contatti from "@/pages/Contatti";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-pietra-light text-grafite min-h-screen">
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cammino" element={<Cammino />} />
              <Route path="/tappe" element={<Tappe />} />
              <Route path="/tappe/:slug" element={<TappaDetail />} />
              <Route path="/territorio" element={<Territorio />} />
              <Route path="/territorio/:slug" element={<Territorio />} />
              <Route path="/prodotti" element={<Prodotti />} />
              <Route path="/prodotti/:slug" element={<Prodotti />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/progetto" element={<Progetto />} />
              <Route path="/diventa-partner" element={<Partner />} />
              <Route path="/contatti" element={<Contatti />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
